export const ADMIN_TABS = [
  { key: 'stats', label: 'Stats' },
  { key: 'companies', label: 'Companies' },
  { key: 'users', label: 'Users' },
  { key: 'documents', label: 'Documents' },
  { key: 'prompts', label: 'Prompts' },
  { key: 'data', label: 'Data' },
  { key: 'system', label: 'System' },
];

export const adminTabPath = index => `/admin/${ADMIN_TABS[index]?.key || 'stats'}`;

export const DATA_TABS = ['reference-lists', 'section-schemas', 'data-fields', 'chat-content'];
export const dataTabPath = index => `/admin/data/${DATA_TABS[index] || DATA_TABS[0]}`;
